/* Copyright 2015 Bloomberg Finance L.P.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as d3Geo from 'd3-geo';
import { WidgetView } from '@jupyter-widgets/base';
// TODO Inherit from Scale??
export class GeoScale extends WidgetView {
    render() {
        super.render();
        this.createD3Scale();
        this.listenTo(this.model, 'attribute_changed', this.resetScale);
    }
    createD3Scale() {
        this.path = d3Geo.geoPath().projection(this.model.projection);
        this.scale = this.model.projection;
    }
    resetScale() {
        this.createD3Scale();
        this.trigger('domain_changed', null);
    }
}
export class Mercator extends GeoScale {
}
export class Albers extends GeoScale {
}
export class AlbersUSA extends GeoScale {
}
export class EquiRectangular extends GeoScale {
}
export class Orthographic extends GeoScale {
}
export class Gnomonic extends GeoScale {
}
export class Stereographic extends GeoScale {
}
//# sourceMappingURL=GeoScale.js.map